import React, { useState, useEffect } from "react";
import Modal from 'react-modal';
import styles from '../../styles/UserProfile.module.css';
import { useSession, signOut } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useTheme } from "next-themes";
import { Avatar, Button, Divider, Modal as AntModal, Typography } from "antd";
import $ from 'jquery'
import axios from 'axios';
import ApiUrl from '../../url.json';
Modal.setAppElement('#__next');
import StdManageWidget from "../widgets/StdManageWidget";
import { useQueryClient } from "@tanstack/react-query";
import { getHighestPrecedenceRole } from '../../utils/frontendConstant';
import { MdSyncAlt } from 'react-icons/md';

const UserProfileModal = ({ isOpen, onRequestClose }) => {

  //* code for theme */
  const { theme, setTheme } = useTheme();
  useEffect(() => {
    const getSystemTheme = async () => { };
    getSystemTheme();
  }, [setTheme, theme]);
  //* code for theme */

  const { data: session } = useSession();
  const [showWidget, setShowWidget] = useState(false);
  const [showDetails, setShowDetails] = useState({ "userName": "Empty" });
  const router = useRouter();
  const [refreshGenericTable, setRefreshGenericTable] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);
  const [pendingRole, setPendingRole] = useState(null);
  const queryClient = useQueryClient();

  const allRoles = (() => {
    const raw = typeof window !== 'undefined' ? localStorage.getItem('roles') : '';
    if (!raw) return [];
    return Array.isArray(raw) ? raw : raw.split(',').map(r => r.trim()).filter(Boolean);
  })();

  const [activeRole, setActiveRole] = useState(() => {
    if (typeof window === 'undefined') return '';
    return localStorage.getItem('activeRole') || getHighestPrecedenceRole(allRoles);
  });

  const ROLE_COLORS = {
    'Admin': '#e53e3e',
    'Internal Admin': '#3182ce',
    'Internal Manager': '#805ad5',
    'Internal User': '#38a169',
    'External User': '#d69e2e',
    'Test Admin': '#dd6b20',
    'Test User': '#718096',
  };

  const getRoleColor = (role) => ROLE_COLORS[role] || '#074870';

  const handleRoleSwitch = async (newRole) => {
    if (newRole === activeRole || isSwitching) return;
    setIsSwitching(true);
    setPendingRole(null);
    localStorage.setItem('activeRole', newRole);
    setActiveRole(newRole);
    try {
      const jwt = localStorage.getItem('jwt');
      const result = await axios.post(
        ApiUrl.newUrl + '/api/GetMenuBarData',
        { activeRole: newRole },
        { headers: { jwt } }
      );
      if (result.data?.data) {
        localStorage.setItem('menubardata', JSON.stringify(result.data.data));
      }
    } catch (err) {
      console.error('Role switch failed:', err);
    }
    queryClient.clear();
    window.location.href = '/';
  };
  const triggerGenericRefresh = () => {
    setRefreshGenericTable((prev) => !prev);
  };
  useEffect(() => {
    fetchUserDetails();
  }, [])

  const handleSignOut = async () => {
    localStorage.clear();
    document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    await signOut({ redirect: false });
    router.push('/');
    queryClient.clear();
  };

  const fetchUserDetails = () => {
    let userId = localStorage['_id']
    $.ajax({
      type: "GET",
      url:
        ApiUrl.newUrl +
        "/api/dbjsonschema/getPackageInfo/Users" +
        "/" +
        userId,
      dataType: "json",
      async: false,
      headers: { jwt: localStorage.getItem("jwt") },
      success: function (result) {
        if (result) {
          // console.log(result);
          setShowDetails(result.data[0]);
          // console.log('User details fetched sucessfully');
        }
      }, error: function (XMLHttpRequest, textStatus, errorThrown) {
        console.error("Error fetching UserDetails:", textStatus, errorThrown);
      }
    });
  }

  // console.log(showDetails._id);


  const handleEditProfile = () => {
    setShowWidget(true);
    if (onRequestClose) {
      onRequestClose();
    }
  };

  const getLocalValue = (key) => {
    if (typeof window === "undefined") return "";
    return localStorage.getItem(key) || "";
  };

  const userName = getLocalValue("name") || showDetails?.Name || showDetails?.userName || session?.user?.name || "User";
  const userEmail = getLocalValue("userId") || showDetails?.Email || showDetails?.email || session?.user?.email || "Not available";
  const userCompany = getLocalValue("company") || showDetails?.Company || showDetails?.company || "Not available";
  const userRole = activeRole || getLocalValue("roles") || showDetails?.Role || showDetails?.role || "Not available";

  const userInitials = (userName || "U")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((name) => name[0]?.toUpperCase())
    .join("");

  // {open1 && <StdManageWidget open1={open1} setOpen1={setOpen1} 
  // setShowWidget={setShowWidget} mode="edit" currentSchemaName="Users" 
  // currentItemID={showDetails.userName ? '' : localStorage['_id']} currentTitleName="User" />}


  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="User Profile Modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 5000,
          }
        }}
        className={styles.userProfileModalCard}
      >
        {session ? (
          <div className={styles.profileShell}>
            <button className={styles.onRequestClose} onClick={onRequestClose}>
              <span>&times;</span>
            </button>
            <div className={styles.profileHeaderNew}>
              <Avatar className={styles.profileAvatar} size={56}>
                {userInitials}
              </Avatar>
              <div className={styles.profileHeaderText}>
                <Typography.Title level={4} className={styles.profileTitle}>
                  {userName}
                </Typography.Title>
                <Typography.Text className={styles.profileSubtitle}>
                  {userEmail}
                </Typography.Text>
              </div>
            </div>


            <div className={styles.profileInfoGrid}>
              <div className={styles.infoTile}>
                <span className={styles.infoLabel}>Name</span>
                <span className={styles.infoValue}>{userName}</span>
              </div>
              <div className={styles.infoTile}>
                <span className={styles.infoLabel}>Email</span>
                <span className={styles.infoValue}>{userEmail}</span>
              </div>
              <div className={styles.infoTile}>
                <span className={styles.infoLabel}>Company</span>
                <span className={styles.infoValue}>{userCompany}</span>
              </div>
              <div className={styles.infoTile}>
                <span className={styles.infoLabel}>Role</span>
                <span className={styles.infoValue}>{userRole}</span>
              </div>
            </div>

            {allRoles.length > 1 && (
              <>
                <Divider className={styles.profileDivider} />
                <div className={styles.roleSwitchLabel}>Switch Role</div>
                <div className={styles.roleCardList}>
                  {allRoles.map(role => {
                    const isActive = role === activeRole;
                    return (
                      <div
                        key={role}
                        className={`${styles.roleCard} ${isActive ? styles.roleCardActive : ''}`}
                        style={{ opacity: isSwitching && !isActive ? 0.5 : 1 }}
                        onClick={() => !isActive && !isSwitching && setPendingRole(role)}
                      >
                        <span
                          className={styles.roleIndicator}
                          style={{ background: getRoleColor(role) }}
                        />
                        <span className={styles.roleCardName}>{role}</span>
                        {isActive && (
                          <span className={styles.roleCardActiveBadge}>Active</span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            <Divider className={styles.profileDivider} />
            <div className={styles.buttonGroup}>
              <Button className={styles.editProfileBtn} onClick={handleEditProfile}>
                Edit Profile
              </Button>
              <Button danger className={styles.signOutBtnNew} onClick={handleSignOut}>
                Sign Out
              </Button>
            </div>
          </div>
        ) : (
          <p>Please log in</p>
        )}
      </Modal>
      {/* {open1 && <StdManageWidget open1={open1} setShowWidget={setOpen1} */}
      {/* mode="Edit" currentSchemaName="Users"
        currentItemID={showDetails['_id']} currentTitleName="User" userEditProfile="userEditProfile" />} */}

      {showWidget && <StdManageWidget open1={showWidget} setShowWidget={setShowWidget}
        mode="Edit" currentSchemaName="Users"
        currentItemID={showDetails['_id']} currentTitleName="User" userEditProfile="userEditProfile" onRefresh={triggerGenericRefresh} />}

      <AntModal
        open={!!pendingRole}
        onCancel={() => !isSwitching && setPendingRole(null)}
        onOk={() => handleRoleSwitch(pendingRole)}
        okText={isSwitching ? 'Switching...' : 'Switch'}
        cancelText="Cancel"
        okButtonProps={{ disabled: isSwitching, style: { background: '#074870', borderColor: '#074870' } }}
        cancelButtonProps={{ disabled: isSwitching }}
        closable={!isSwitching}
        maskClosable={!isSwitching}
        centered
        zIndex={6000}
        title={null}
        width={360}
      >
        <div className={styles.confirmBody}>
          <div className={styles.confirmIcon}><MdSyncAlt /></div>
          <p className={styles.confirmHeading}>Switch Role?</p>
          <p className={styles.confirmSub}>You are switching to</p>
          {pendingRole && (
            <div className={styles.confirmRoleChip}>
              <span className={styles.confirmDot} style={{ background: getRoleColor(pendingRole) }} />
              {pendingRole}
            </div>
          )}
          <p className={styles.confirmSub}>The page will reload and the menu will update.</p>
        </div>
      </AntModal>

    </>
  );

};

export default UserProfileModal;
